/**
 * Renderer UNICO del corpo articolo: usato dall'anteprima admin e dalla pagina pubblica.
 * La tipografia vive solo in .article-content (index.css) — non aggiungere regole qui.
 */
export function ArticleContent({ html, className = "", testId }) {
  return (
    <div
      className={`article-content ${className}`}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: html || "" }}
    />
  );
}
